import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  results: [
    {
      id: 0,
      name: '',
      email: '',
      signupDate: '2016-01-01',
      role: null,
    },
  ],
  admin: {
    id: 0,
    name: '',
    email: '',
    signupDate: '2016-01-01',
    role: null,
  },
  navigationType: false,
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/admins?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 1,
    limit: 20,
  },
};

// all the returns here could be literals instead of using assign
function admins(state = initialState, action) {
  switch (action.type) {
    case types.ADMINS_FETCH_SUCCESS:
      return assign({}, state, action.res);
    case types.ADMIN_DELETE_ERROR:
    case types.ADMINS_FETCH_ERROR:
    case types.ADMIN_FETCH_ERROR:
    case types.ADMIN_EDIT_ERROR:
    case types.ADMIN_SET_ERROR:
      return assign({}, state, {
        error: action.res,
      });
    case types.ADMIN_DELETE_SUCCESS:
      return assign({}, state, {
        adminDelete: action.res.ok,
      });
    case types.ADMIN_FETCH_SUCCESS:
    case types.ADMIN_EDIT_SUCCESS:
    case types.ADMIN_SET_SUCCESS:
      return assign({}, state, {
        admin: action.res,
      });
    case types.NAVIGATION_TYPE:
      return assign({}, state, {
        navigationType: action.res,
      });
    case types.ADMINS_CLEAR_ERRORS:
      return assign({}, state, {
        error: '',
      });
    default:
      return state;
  }
}

export default admins;



// WEBPACK FOOTER //
// ./src/reducers/admins.js